import type { PageMeta } from "./en";

/** Graha-mantra leaf metadata, split from the root catalog as one coherent family. */
export const enMantras: Record<string, PageMeta> = {
  "mantras/surya": {
    title: "Surya Mantra — Beej Mantra for Sun, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Surya mantra guide — Om Hraam Hreem Hraum Sah Suryaya Namah beej mantra, Rigveda Vedic mantra, Surya Gayatri.",
  },
  "mantras/chandra": {
    title: "Chandra Mantra — Beej Mantra for Moon, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Chandra mantra guide — Om Shraam Shreem Shraum Sah Chandraya Namah beej mantra.",
  },
  "mantras/mangal": {
    title: "Mangal Mantra — Beej Mantra for Mars, Mangal Dosh Upay | Ishvaram",
    description:
      "Complete Mangal mantra guide — Om Kraam Kreem Kraum Sah Bhaumaya Namah beej mantra. Jaap method and upay for Mangal Dosh and afflicted Mars in kundali.",
  },
  "mantras/budh": {
    title: "Budh Mantra — Beej Mantra for Mercury, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Budh mantra guide — Om Braam Breem Braum Sah Budhaya Namah beej mantra. Jaap method and upay for weak or combust Mercury (Budh) in kundali.",
  },
  "mantras/guru": {
    title: "Guru Mantra — Beej Mantra for Jupiter, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Guru (Jupiter) mantra guide — Om Graam Greem Graum Sah Gurave Namah beej mantra. Jaap method and upay for weak Jupiter and Guru Chandal Yoga.",
  },
  "mantras/shukra": {
    title: "Shukra Mantra — Beej Mantra for Venus, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Shukra (Venus) mantra guide — Om Draam Dreem Draum Sah Shukraya Namah beej mantra. Jaap method and upay for weak Venus and relationship problems.",
  },
  "mantras/shani": {
    title: "Shani Mantra — Beej Mantra for Saturn, Sade Sati Upay | Ishvaram",
    description:
      "Complete Shani mantra guide — Om Praam Preem Praum Sah Shanaischaraya Namah beej mantra.",
  },
  "mantras/rahu": {
    title: "Rahu Mantra — Beej Mantra for Rahu, Kaal Sarp Dosh Upay | Ishvaram",
    description:
      "Complete Rahu mantra guide — Om Bhraam Bhreem Bhraum Sah Rahave Namah beej mantra.",
  },
  "mantras/ketu": {
    title: "Ketu Mantra — Beej Mantra for Ketu, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Ketu mantra guide — Om Sraam Sreem Sraum Sah Ketave Namah beej mantra, jaap method, and upay for Ketu Mahadasha and Kaal Sarp Dosh.",
  },
};
